import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';

interface Props {
  content: string;
}

const UzyToolSaveProduct: React.FC<Props> = ({ content }) => {
  let product: Record<string, any> = {};
  try { product = JSON.parse(content); } catch { /* ignore */ }

  const filePath = product.file_path || '';
  const downloadUrl = filePath.startsWith('/') ? filePath : `/${filePath}`;

  const handleDownload = async (e: React.MouseEvent) => {
    e.preventDefault();
    const backendOrigin = (process.env.REACT_APP_API_URL || '').replace(/\/api\/v1$/, '') || window.location.origin;
    const fullUrl = `${backendOrigin}${downloadUrl}`;
    if ((window as any).__TAURI__) {
      const { invoke } = await import('@tauri-apps/api/core');
      await invoke('open_local_app', { path: fullUrl });
    } else {
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = filePath.split('/').pop() || 'download';
      a.click();
    }
  };

  return (
    <div className="uzy-tool-card">
      <div className="uzy-tool-card-header">产物生成</div>
      <div className="uzy-tool-card-body">
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>名称：</b>{product.name || ''}</div>
        <div style={{ whiteSpace: 'nowrap' }}><b>类型：</b>{product.product_type || ''}{product.size ? <span>　<b>大小：</b>{product.size}</span> : ''}</div>
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>描述：</b>{product.description || ''}</div>
        {filePath && (
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <a href={downloadUrl} onClick={handleDownload} style={{ fontSize: 13, color: '#0071e3', display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
              <DownloadOutlined /> 下载
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default UzyToolSaveProduct;
